import { LawTerm } from "@/models/law-term/LawTerm";
import { create } from "zustand";

interface LawDictionaryState {
  isDialogOpen: boolean;
  searchTerm: string;
  selectedLetter: string;
  selectedTerm: LawTerm | null;
  setIsDialogOpen: (isOpen: boolean) => void;
  setSearchTerm: (term: string) => void;
  setSelectedLetter: (letter: string) => void;
  setSelectedTerm: (term: LawTerm | null) => void;
  reset: () => void;
}

const initialState = {
  isDialogOpen: false,
  searchTerm: "",
  selectedLetter: "alle",
  selectedTerm: null,
};

const useLawDictionaryStore = create<LawDictionaryState>((set) => ({
  ...initialState,
  setIsDialogOpen: (isOpen) => set({ isDialogOpen: isOpen }),
  setSearchTerm: (term) => set({ searchTerm: term }),
  setSelectedLetter: (letter) => set({ selectedLetter: letter }),
  setSelectedTerm: (term) => set({ selectedTerm: term }),
  reset: () => set(initialState),
}));

export default useLawDictionaryStore;
